import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b6e25e06"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "no-user-content"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-text"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, [/*#__PURE__*/_createTextVNode(" 登录 "), /*#__PURE__*/_createElementVNode("span", {
  class: "english-menu"
}, " / Sign in")])], -1));

const _hoisted_3 = {
  class: "login-content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "开启智慧教学之旅", -1));

const _hoisted_5 = {
  class: "avatar"
};
const _hoisted_6 = ["src"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "智慧树账号登录", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = {
  key: 1,
  style: {
    "position": "relative"
  }
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "toggle-tip"
}, [/*#__PURE__*/_createTextVNode(" 切换 "), /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-qiehuan"
})], -1));

const _hoisted_12 = {
  key: 1,
  class: "user-content"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-text"
}, [/*#__PURE__*/_createElementVNode("img", {
  width: "10",
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202408/cf59ea85362e43e891746339b1592e70.png"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "user-name"
}, "教学管理")], -1));

const _hoisted_14 = {
  key: 2,
  class: "user-content"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-text"
}, [/*#__PURE__*/_createElementVNode("img", {
  width: "10",
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202408/cf59ea85362e43e891746339b1592e70.png"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "user-name"
}, "教学管理")], -1));

const _hoisted_16 = {
  key: 3,
  class: "user-content"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-text"
}, [/*#__PURE__*/_createElementVNode("img", {
  width: "20",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/9d541367079649008f27112cdc578ef2.png"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "user-name"
}, "教学管理")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_RoleCard = _resolveComponent("RoleCard");

  return _openBlock(), _createElementBlock("div", null, [!$props.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: require('@/assets/images/home/Booklist.png'),
    alt: ""
  }, null, 8, _hoisted_6)]), _createElementVNode("div", {
    class: "login-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.zhsLogin && $options.zhsLogin(...args))
  }, _hoisted_9)])])) : _createCommentVNode("", true), $props.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_10, [$props.zhsRole == 1 || $props.zhsRole == 2 ? (_openBlock(), _createBlock(_component_el_dropdown, {
    key: 0,
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
      class: "role-dropdown"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roleList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: item.name,
          onClick: $event => $options.toggleZhsRole(item, index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_hoisted_11]),
    _: 1
  })) : _createCommentVNode("", true), $data.currentRole == 3 || $data.currentRole == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_hoisted_13, _createVNode(_component_RoleCard, {
    menuList: $data.studentMenu,
    onlineLink: $data.onlineLink.student,
    zhsRole: $data.currentRole
  }, null, 8, ["menuList", "onlineLink", "zhsRole"])])) : _createCommentVNode("", true), $data.currentRole == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _createVNode(_component_RoleCard, {
    menuList: $data.teacherMenu,
    onlineLink: $data.onlineLink.teacher,
    zhsRole: $data.currentRole
  }, null, 8, ["menuList", "onlineLink", "zhsRole"])])) : _createCommentVNode("", true), $data.currentRole == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_hoisted_17, _createVNode(_component_RoleCard, {
    menuList: $data.manageMenu,
    onlineLink: $data.onlineLink.manage,
    zhsRole: $data.currentRole
  }, null, 8, ["menuList", "onlineLink", "zhsRole"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}